import { useEffect } from "react";
import { useActionToast } from "../stores/actionToast";

export function ActionToast() {
  const toasts = useActionToast((s) => s.toasts);
  const dismiss = useActionToast((s) => s.dismiss);

  useEffect(() => {
    if (toasts.length === 0) return;
    const timers = toasts.map((t) => setTimeout(() => dismiss(t.id), 6000));
    return () => timers.forEach(clearTimeout);
  }, [toasts, dismiss]);

  if (toasts.length === 0) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <div key={t.id} role="alert" className="flex items-center gap-3 rounded-lg bg-gray-900 text-white px-4 py-2 shadow-lg">
          <span className="flex-1">{t.message}</span>
          <button type="button" className="font-medium underline"
            onClick={() => { t.onAction(); dismiss(t.id); }}>{t.actionLabel}</button>
        </div>
      ))}
    </div>
  );
}
